import React, { useState } from "react";
import { Link } from "react-router-dom";
import styles from "./Navbar.module.css";
import logo from "../../assets/logo.png";

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
   <nav className={styles.navbar}>
  <div className={styles.container}>

    <img src={logo} alt="logo" className={styles.logo} />

    <div className={styles.hamburger} onClick={() => setOpen(!open)}>
      ☰
    </div>

    <ul className={`${styles.navLinks} ${open ? styles.active : ""}`}>
      {/* links */}
    </ul>

<ul className={`${styles.navLinks} ${open ? styles.active : ""}`}>
        <li><Link to="/">Home</Link></li>
        <li><Link to="/about">About</Link></li>
        <li><Link to="/gallery">Gallery</Link></li>
        <li><Link to="/curriculum">Curriculum</Link></li>
        <li><Link to="/contact">Contact Us</Link></li>

        {/* CALL BUTTON */}
        <li>
          <a href="tel:9650817621" className={styles.callBtn}>
            📞 Call Now
          </a>
        </li>
      </ul>





  </div>
</nav>

   
      
  );
};

export default Navbar;